"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerPurchaseResponseType;
(function (CustomerPurchaseResponseType) {
    CustomerPurchaseResponseType["LinearPayPerViewPurchase"] = "CustomerLinearPayPerViewPurchase";
    CustomerPurchaseResponseType["AccountInArrearsError"] = "CustomerAccountInArrearsError";
    CustomerPurchaseResponseType["InvalidAccountForPurchase"] = "InvalidCustomerAccountForPurchase";
    CustomerPurchaseResponseType["CustomerTvodPurchaseSuccess"] = "CustomerTvodPurchase";
})(CustomerPurchaseResponseType = exports.CustomerPurchaseResponseType || (exports.CustomerPurchaseResponseType = {}));
//# sourceMappingURL=Customer.js.map